import React from "react";

const SettingsFormContext = React.createContext({});

export default SettingsFormContext;
